export const REGION_TYPE = {
  PARKING_LOT: "停車場閘門",
  ENTRANCE: "門禁出入",
  PUBLIC_LIGHTING: "公共照明",
};

export const SWITCHER_STATUS_TYPE = {
  OFF: 0, // 關閉
  ON: 1, // 開啟
};
